import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

const mainOf = (s) => (s.match(/\/static\/js\/main\.[\w]+\.js/) || [])[0] || "";
const running = () => mainOf([...document.scripts].map((x) => x.src).join(" "));

export function UpdateBanner() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const mine = running();
    if (!mine) { return undefined; }
    const check = async () => {
      if (!navigator.onLine || document.visibilityState === "hidden") { return; }
      try {
        const html = await (await fetch(`/?check=${Date.now()}`, { cache: "no-store" })).text();
        const latest = mainOf(html);
        if (latest && latest !== mine) { setReady(true); }
      } catch (e) { /* offline */ }
    };
    const t = setTimeout(check, 4000);
    const iv = setInterval(check, 10 * 60 * 1000);
    window.addEventListener("online", check);
    document.addEventListener("visibilitychange", check);
    return () => { clearTimeout(t); clearInterval(iv); window.removeEventListener("online", check); document.removeEventListener("visibilitychange", check); };
  }, []);
  const update = async () => {
    const reg = await navigator.serviceWorker?.getRegistration();
    await reg?.update().catch(() => {});
    window.location.reload();
  };
  if (!ready) { return null; }
  return (
    <button type="button" onClick={update} data-testid="update-banner"
      className="no-print fixed bottom-4 left-1/2 z-[200] flex -translate-x-1/2 items-center gap-2 rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white shadow-xl transition-transform hover:scale-105">
      <RefreshCw className="h-4 w-4" /> New version available, tap to update
    </button>
  );
}
